import { render, staticRenderFns } from "./event-schedule.vue?vue&type=template&id=32a0ec50&scoped=true"
import script from "./event-schedule.ts?vue&type=script&lang=ts&external"
export * from "./event-schedule.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a0ec50",
  null
  
)

export default component.exports